// Obtendo o valor do atributo data-tempodelay como uma string (tempo padrão)
var tempoDelayString = document.querySelector("#banner-slide").dataset.tempodelay;

// Convertendo a string em um número (float)
var tempoDelay = parseFloat(tempoDelayString);

// Multiplicando por 1000 para converter para milissegundos
var tempoFinal = tempoDelay * 1000;


const swiper = new Swiper('#banner-slide', {
  effect: "fade",
  autoplay: {
    delay: tempoFinal, // tempo padrão, mas será sobrescrito pelo data-swiper-autoplay de cada slide
    disableOnInteraction: false
  },
  navigation: {
    nextEl: '#banner-bloco-next',
    prevEl: '#banner-bloco-prev',
  },
  pagination:{
    el: "#banner-bloco-pagination",
    clickable: true
  },
  lazyLoading: true,
  loop: true,
});

// Gerenciamento de vídeos
swiper.on('slideChange', function () {
  // Pausar todos os vídeos
  const allVideos = document.querySelectorAll('.banner-bloco-video');
  allVideos.forEach(video => {
    if (video.tagName === 'VIDEO') {
      video.pause();
    }
  });

  // Reproduzir vídeo do slide ativo
  const activeSlide = swiper.slides[swiper.activeIndex];
  const activeVideo = activeSlide ? activeSlide.querySelector('.banner-bloco-video') : null;
  
  if (activeVideo && activeVideo.tagName === 'VIDEO') {
    activeVideo.currentTime = 0; // Reiniciar do início
    activeVideo.play().catch(error => {
      console.log('Erro ao reproduzir vídeo:', error);
    });
  }
});

// Iniciar vídeo do primeiro slide após carregar
swiper.on('init', function() {
  const firstSlide = swiper.slides[swiper.activeIndex];
  const firstVideo = firstSlide ? firstSlide.querySelector('.banner-bloco-video') : null;
  
  if (firstVideo && firstVideo.tagName === 'VIDEO') {
    firstVideo.play().catch(error => {
      console.log('Erro ao reproduzir vídeo:', error);
    });
  }
});

// Trigger manual do evento init se o swiper já estiver inicializado
const firstSlide = swiper.slides[swiper.activeIndex];
const firstVideo = firstSlide ? firstSlide.querySelector('.banner-bloco-video') : null;

if (firstVideo && firstVideo.tagName === 'VIDEO') {
  firstVideo.play().catch(error => {
    console.log('Erro ao reproduzir vídeo:', error);
  });
}
